import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { Box } from '@mui/material';
import { club } from 'apis';
import { useQuery } from 'react-query';

interface ClubAvatarImageProps {
    clubId?: string;
    alt?: string;
    iconSize?: number;
    sx?: any;
}

const ClubAvatarImage = ({ clubId, alt = 'Club image', iconSize = 56, sx }: ClubAvatarImageProps) => {
    const avatarQuery = useQuery(
        ['clubAvatar', { recordGuid: clubId, projectTableId: 1 }],
        async () => {
            if (!clubId) return null;

            try {
                return await club.getAvatar({ recordGuid: clubId, projectTableId: 1 });
            } catch {
                return null;
            }
        },
        {
            enabled: !!clubId,
            suspense: false,
            staleTime: 1000 * 60 * 15
        }
    );

    const avatarSrc = typeof avatarQuery.data === 'string' && avatarQuery.data.trim() ? avatarQuery.data : '';

    return (
        <Box
            sx={[
                {
                    borderRadius: 3,
                    border: '1px solid #d7e0ea',
                    background:
                        'linear-gradient(135deg, rgba(231, 240, 249, 0.95), rgba(246, 248, 251, 0.95)), radial-gradient(circle at 20% 20%, rgba(80, 135, 180, 0.18), transparent 30%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#7b8b9b',
                    overflow: 'hidden'
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
        >
            {avatarSrc ? (
                <Box component="img" src={avatarSrc} alt={alt} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
                <ImageOutlinedIcon sx={{ fontSize: iconSize }} />
            )}
        </Box>
    );
};

export default ClubAvatarImage;
